module.exports = __webpack_public_path__ + "media/inserate/assets/images/teaser-09d7338ca879e2d8e530b18821ce6ceb.png";